export default "__VITE_ASSET__tjChvXHS__"